.container {
  justify-content: space-between;
}

.note {
  color: var(--tuna-palette-secondary-light);
}
